import React from "react";
import PropTypes from "prop-types";

import css from "./FeatureMediaHeader.module.scss";

import FeatureImageHeaderContent from "components/FeatureImageHeaderContent";
import MediaWrapper from "components/MediaWrapper";

const FeatureMediaHeader = ({ media, content }) => {
    return (
        <MediaWrapper
            media={media}
            stickyDuration={30}
            theme={MediaWrapper.themes.fixed}
            gradient={MediaWrapper.gradients.feature}
            bottomAligned={true}
        >
            <FeatureImageHeaderContent
                {...content}
                showIcon={true}
                shouldAnimate={true}
            />
        </MediaWrapper>
    );
};

FeatureMediaHeader.propTypes = {
    media: PropTypes.shape({ isSticky: PropTypes.bool }),
    content: PropTypes.object
};

export default FeatureMediaHeader;



// WEBPACK FOOTER //
// ./src/components/FeatureMediaHeader/FeatureMediaHeader.jsx